import React from "react";
import PropTypes from "prop-types";
import MenuItems from "./MenuItems";
import "./LeftMenu.css";
import {Dialog, DialogActions, DialogContent, DialogTitle, Divider, ListItem} from '@material-ui/core';
import MenuItem from './MenuItem';
import LogoutIcon from '@mui/icons-material/Logout';
import {Button} from "@mui/material";

class LeftMenu extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      width: '0', // Default width
      open: false,
    };
    this.leftMenuRef = React.createRef();
  }

  componentDidMount() {
    this.calculateWidth();
    window.addEventListener('resize', this.calculateWidth);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.calculateWidth);
  }

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleConfirmLogout = () => {
    this.setState({ open: false }, () => {
      this.props.logout();
    });
  };
  calculateWidth = () => {
    if (this.leftMenuRef.current) {
      const newWidth =
        this.leftMenuRef.current.parentElement.offsetWidth +
        this.leftMenuRef.current.offsetWidth -
        this.leftMenuRef.current.clientWidth +
        'px';
      // Update width only if it has changed
      this.setState((prevState) => {
        if (prevState.width !== newWidth) {
          return { width: newWidth };
        }
        return null;
      });
    }
  };

  render() {
    return (
      <div
        className="leftMenu"
        style={{ overflowY: 'hidden', overflowX: 'hidden' }}
      >
        <div
          ref={this.leftMenuRef}
          className="leftMenu"
          style={{
            top: '75px',
            paddingBottom: '100px',
            width: this.state.width,
            overflowX: 'hidden',
          }}
        >
          <MenuItems
            user={this.props.user}
            routes={this.props.routes}
            userRoutes={this.props.userRoutes}
            isDrawer={this.props.isDrawer}
            closeDrawer={this.props.closeDrawer}
          />
          <Dialog
              open={this.state.open}
              onClose={this.handleClose}
              PaperProps={{
                style: {
                  width: '400px',
                  maxWidth: '90%',
                  borderRadius: '12px',
                  padding: '8px'
                }
              }}
          >
            <DialogTitle>{'Confirmation'}</DialogTitle>

            <DialogContent style={{ textAlign: 'left', fontSize: '16px',marginTop:'-8px',marginBottom:'8px' }}>
              Are you sure you want to logout?
            </DialogContent>

            <DialogActions>
              <div className="logout-dialog-buttons">
                <Button
                    onClick={this.handleClose}
                    style={{ backgroundColor: 'darkgray', color: 'white' }}
                    variant="contained"
                    fullWidth
                >
                  No
                </Button>

                <Button
                    onClick={this.handleConfirmLogout}
                    style={{
                      backgroundColor: "rgb(0, 22, 101)",
                      color: 'white',
                    }}
                    variant="contained"
                    fullWidth
                >
                  Yes, Logout
                </Button>
              </div>
            </DialogActions>
          </Dialog>

          <ListItem
            button
            className="leftMenu-item"
            onClick={this.handleClickOpen}
          >
            <MenuItem
              className="leftMenu-item"
              item={{ label: 'Logout', icon: LogoutIcon }}
            />
          </ListItem>
          <Divider style={{ backgroundColor: '#282c5e', height: '3px' }} />
        </div>
      </div>
    );
  }
}

LeftMenu.propTypes = {
  routes: PropTypes.array,
  userRoutes: PropTypes.array,
  isDrawer: PropTypes.bool,
  closeDrawer: PropTypes.func,
  logout: PropTypes.func,
};

LeftMenu.defaultProps = {
  routes: [],
  userRoutes: [],
  isDrawer: false,
  closeDrawer: () => {},
  logout: () => {},
};


export default LeftMenu;